import { Box, Typography } from '@mui/material';
import _ from 'lodash';
import React from 'react';
import { EventStatus } from '../../types/Event';

const STATUS_COLORS: Record<string, string> = {
  planning: '#c0c0c0',
  in_progress: '#AD49E1',
  scheduled: '#42A5F5',
  complete: '#35B23D',
};

interface IStatusPillProps {
  status: EventStatus;
  text?: string;
  color?: string;
}

const StatusPill: React.FC<IStatusPillProps> = ({ status, text, color }) => {
  const snakeCaseStatus = _.snakeCase(status);
  const displayText = text || _.startCase(_.toLower(snakeCaseStatus));
  const backgroundColor = color || STATUS_COLORS[snakeCaseStatus] || '#c0c0c0';

  const pillStyles = {
    padding: '4px 8px',
    gap: '8px',
    borderRadius: '6px',
    background: `${backgroundColor}30`,
    border: `1px solid ${backgroundColor}80`,
    fontWeight: 500,
    textAlign: 'center',
    display: 'inline-flex',
    alignItems: 'center',
    minWidth: '100px',
    height: '28px',
    justifyContent: 'center',
  };

  return (
    <Box sx={pillStyles}>
      <Typography variant="body2" noWrap>
        {displayText}
      </Typography>
    </Box>
  );
};

export default StatusPill;
